import "./assets/css/base.scss";

import "element-plus/theme-chalk/display.css";
import "./assets/scss/app.scss";

// main.ts
import { createApp } from "vue";
import ElementPlus from "element-plus";
import locale from "element-plus/lib/locale/lang/en";
import "element-plus/dist/index.css";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import store from "./store";
import App from "./App.vue";
import UserAvatar from "@/components/auth/UserAvatar";
import GlobalHelper from "@/mixins/GlobalHelper";
import * as Icons from "@element-plus/icons-vue";
import HighchartsVue from "highcharts-vue";
import { installDateMask } from "@/directives/dateMask";
import { startIdleSession } from "@/helpers/idleSession";

const app = createApp(App);
for (let i in Icons) {
  app.component(i, Icons[i]);
}
app.component("UserAvatar", UserAvatar);
app.use(ElementPlus);
app.use(router);
app.use(HighchartsVue);
app.use(ElementPlus, {
  locale,
});

app.mixin(GlobalHelper);
app.use(store);
app.use(VueAxios, axios);
const bootstrap = async () => {
  const authenticationDestination = await store.dispatch(
    "auth/initializeAuthentication"
  );
  app.mount("#app");

// Warn, then sign out, users who have been inactive.
startIdleSession();

  if (authenticationDestination) {
    await router.isReady();
    await router.replace(authenticationDestination);
  }

  // Mask single-date picker inputs so users can only type a valid date.
  installDateMask();

  // Initialize socket connection for real-time fax notifications
  initSocket();
};

bootstrap();